"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.setShowNames = exports.setDashboardStaffStats = exports.setDashboardStats = exports.setDashboardQuarantineEndingSoonStaff = exports.setDashboardIsolationEndingSoonStaff = exports.setDashboardPendingStaff = exports.setDashboardQuarantineEndingSoon = exports.setDashboardIsolationEndingSoon = exports.setDashboardPending = exports.setCurrentSchool = void 0;
var toolkit_1 = require("@reduxjs/toolkit");
var dashboardSlice = toolkit_1.createSlice({
    name: 'dashboard',
    initialState: { currentSchool: '', showNames: false, stats: null, staffStats: null },
    reducers: {
        setCurrentSchool: function (state, action) {
            return __assign(__assign({}, state), { currentSchool: action.payload, stats: null, staffStats: null });
        },
        setShowNames: function (state, action) {
            return __assign(__assign({}, state), { showNames: action.payload });
        },
        setDashboardStats: function (state, action) {
            return __assign(__assign({}, state), { stats: action.payload });
        },
        setDashboardPending: function (state, action) {
            return __assign(__assign({}, state), { stats: __assign(__assign({}, state.stats), { pendingUsers: action.payload }) });
        },
        setDashboardIsolationEndingSoon: function (state, action) {
            return __assign(__assign({}, state), { stats: __assign(__assign({}, state.stats), { isolationEndingSoon: action.payload }) });
        },
        setDashboardQuarantineEndingSoon: function (state, action) {
            return __assign(__assign({}, state), { stats: __assign(__assign({}, state.stats), { quarantineEndingSoon: action.payload }) });
        },
        setDashboardStaffStats: function (state, action) {
            return __assign(__assign({}, state), { staffStats: action.payload });
        },
        setDashboardPendingStaff: function (state, action) {
            return __assign(__assign({}, state), { staffStats: __assign(__assign({}, state.staffStats), { pendingUsers: action.payload }) });
        },
        setDashboardIsolationEndingSoonStaff: function (state, action) {
            return __assign(__assign({}, state), { staffStats: __assign(__assign({}, state.staffStats), { isolationEndingSoon: action.payload }) });
        },
        setDashboardQuarantineEndingSoonStaff: function (state, action) {
            return __assign(__assign({}, state), { staffStats: __assign(__assign({}, state.staffStats), { quarantineEndingSoon: action.payload }) });
        },
    },
});
exports.setCurrentSchool = (_a = dashboardSlice.actions, _a.setCurrentSchool), exports.setDashboardPending = _a.setDashboardPending, exports.setDashboardIsolationEndingSoon = _a.setDashboardIsolationEndingSoon, exports.setDashboardQuarantineEndingSoon = _a.setDashboardQuarantineEndingSoon, exports.setDashboardPendingStaff = _a.setDashboardPendingStaff, exports.setDashboardIsolationEndingSoonStaff = _a.setDashboardIsolationEndingSoonStaff, exports.setDashboardQuarantineEndingSoonStaff = _a.setDashboardQuarantineEndingSoonStaff, exports.setDashboardStats = _a.setDashboardStats, exports.setDashboardStaffStats = _a.setDashboardStaffStats, exports.setShowNames = _a.setShowNames;
exports.default = dashboardSlice.reducer;
